import { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { createCheckin, createGuests } from "../api";
import logo from "../images/logo.png";
import stand1 from "../images/stand1.png";
import standoc from "../images/standoc.png";
import selectedS from "../images/selectedStand.png";
import polyhalle from "../images/hangar.png";
import polyhalle_selected from "../images/hangar-selected.png";
import CheckinSuccess from "./ChecInOutConfirmation";
import "./CheckinComponent.css";

export default function CheckinComponent(data) {
  let contact = data.session.details.output
    ? JSON.parse(data.session.details.output)
    : {};
  let mitgliednummer = contact.mitgliedNummer || "N/A";
  let kundenName = contact.kundenName || "N/A";
  let laufzeit = contact.laufzeit || "N/A";
  let currntTerm = contact.aboEndzeit || "N/A";
  let guest = `${contact.guest || 0}/5` || "0/5";
  let unavailableStands = data.session.notAvailableStands || [];
  const [stand, setStand] = useState("");
  // Form submission handler
  const onSubmit = async (data) => {
    setStand(data.stand);
    console.log(data);
    //require format 14.12.2025 05:30 PM
    let rowFormat = new Date().toLocaleString("de-DE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    data.checkInZeit = rowFormat.replace(",", "");
    // Here you can handle the form data, e.g., send it to a server and render a confirmation component
    try {
      const resp = await createCheckin(data);
      console.log("Check-in created:", resp);
      let checinRes = JSON.parse(resp?.zohoResponse?.details?.output);
      let id = checinRes?.id || null;
      console.log("after checkin request 1", id);
      // create guest records if any
      if (data.guests && data.guests.length > 0) {
        const guestResp = await createGuests({
          guests: data.guests,
          mitgliedNummer: data.memberId,
          checinRes: id,
        });
        console.log("Guests created:", guestResp);
      }
      setStep(3);
    } catch (err) {
      console.error("Check-in error:", err);
    }
    console.log("after checkin request");
  };
  //
  const [step, setStep] = useState(1);
  const [selectedStand, setSelectedStand] = useState(null);
  const [dateTime, setDateTime] = useState(new Date());

  const {
    register,
    handleSubmit,
    setValue,
    control,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fullName: kundenName,
      memberId: mitgliednummer,
      subscription: laufzeit,
      aboEndzeit: currntTerm,
      gast: guest,
      stand: "",
      guests: [{ firstName: "", lastName: "" }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "guests",
  });

  const goToGuestStep = () => setStep(2);
  const goBackToMainStep = () => setStep(1);

  useEffect(() => {
    register("stand", {
      required: "Please select a stand",
    });

    setValue("stand", selectedStand);

    const interval = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, [register, selectedStand, setValue]);
  // console.log(dateTime)

  return (
    <div className="checkin-container">
      {/* HEADER */}
      <div className="checkin-header">
        <img src={logo} alt="logo" width="400px" />

        <div className="header-datetime">
          <div>{dateTime.toLocaleDateString()}</div>
          <div>{dateTime.toLocaleTimeString()}</div>
        </div>
      </div>

      {/* ================= STEP 1 ================= */}
      {step === 1 && (
        <form className="checkin-form" onSubmit={handleSubmit(onSubmit)}>
          {/* FORM FIELDS */}
          <div className="checkin-fields-2-column">
            <div className="checkin-field">
              <label className="checkin-label">Vor- und Nachname</label>
              <input
                className="checkin-input readonly"
                {...register("fullName")}
                readOnly
              />
            </div>

            <div className="checkin-field">
              <label className="checkin-label">Abonummer:</label>
              <input
                className="checkin-input readonly"
                {...register("memberId")}
                readOnly
              />
            </div>

            <div className="checkin-field">
              <label className="checkin-label">Abotyp:</label>
              <input
                className="checkin-input readonly"
                {...register("subscription")}
                readOnly
              />
            </div>

            {/* <div className="checkin-field">
              <label className="checkin-label">Laufzeit:</label>
              <input className="checkin-input readonly" {...register("duration")} readOnly />
            </div> */}

            <div className="checkin-field">
              <label className="checkin-label">Abo Endzeit:</label>
              <input
                className="checkin-input readonly"
                {...register("aboEndzeit")}
                readOnly
              />
            </div>

            <div className="checkin-field">
              <label className="checkin-label">Total Gäste:</label>
              <input
                className="checkin-input readonly"
                {...register("gast")}
                readOnly
              />
            </div>
          </div>
          {/* STAND GRID */}
          {errors.stand && (
            <div className="form-error-top">{errors.stand.message}</div>
          )}
          <div className="stand-box">
            <div className="stand-grid">
              {[
                "Bahn 1",
                "Bahn 2",
                "Bahn 3",
                "Bahn 4",
                "Bahn 5",
                "Bahn 6",
                "Bahn 7",
                "Bahn 8",
                "Bahn 9",
                "Bahn 10",
                "Polyhalle",
              ].map((stand, index) => {
                const standNo = index + 1;
                const isOccupied = unavailableStands.includes(standNo);
                const isSelected = selectedStand === standNo;

                return (
                  <div
                    key={index}
                    className={`stand-item ${isSelected ? "selected" : ""}`}
                    onClick={() => !isOccupied && setSelectedStand(standNo)}
                  >
                    <img
                      src={
                        isOccupied
                          ? standoc
                          : isSelected
                            ? index === 10
                              ? polyhalle_selected
                              : selectedS
                            : index === 10
                              ? polyhalle
                              : stand1
                      }
                      className="stand-icon"
                    />
                    {
                      //isOccupied ? "#D3D3D3" : isSelected ? "#00ff00" : "#000000"
                    }
                    <div
                      className="stand-label"
                      style={{
                        color: isOccupied
                          ? "#D3D3D3"
                          : isSelected
                            ? "#00ff00"
                            : "#000000",
                      }}
                    >
                      {stand}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="stand-legend">
              <div>
                <span className="legend-box free"></span> = Frei
              </div>
              <div>
                <span className="legend-box used"></span> = Besetzt
              </div>
            </div>
          </div>

          {/* BUTTONS */}
          <div className="btn-row">
            <button
              type="submit"
              className="btn-add-guest"
              onClick={async () => {
                const isValid = await trigger("stand"); // validate stand only

                if (isValid) {
                  goToGuestStep(); // go to step 2 only if stand selected
                }
              }}
            >
              + Gast Hinzufügen
            </button>

            <button type="submit" className="guest-checkin">
              Bestätigen
            </button>
            <button
              type="submit"
              className="Abrechen-checkin"
              onClick={() => {
                setSelectedStand(null);
                data.onDone();
              }}
            >
              Abbrechen
            </button>
          </div>
        </form>
      )}
      {/* ================= STEP 2 ================= */}
      {step === 2 && (
        <div className="guest-container">
          <form onSubmit={handleSubmit(onSubmit)} className="guest-form">
            {/* REPEATER ROWS */}
            {fields.map((item, index) => (
              <div className="guest-row" key={item.id}>
                <div className="guest-field">
                  <label className="guest-label">Vorname:</label>
                  <input
                    className="guest-input"
                    {...register(`guests.${index}.firstName`)}
                  />
                </div>

                <div className="guest-field">
                  <label className="guest-label">Nachname:</label>
                  <input
                    className="guest-input"
                    {...register(`guests.${index}.lastName`)}
                  />
                </div>

                {/* OPTIONAL REMOVE BUTTON (after first row) */}
                {index !== 0 && (
                  <button
                    type="button"
                    className="guest-remove-btn"
                    onClick={() => remove(index)}
                  >
                    ✕
                  </button>
                )}
              </div>
            ))}

            <div className="guest-required">*</div>
            <div className="btn-row">
              {/* ADD BUTTON (MAX 5) */}
              {fields.length < 5 && (
                <button
                  type="button"
                  className="guest-add-btn"
                  onClick={() => append({ firstName: "", lastName: "" })}
                >
                  <span className="guest-plus">+</span>
                  Weiteren Gast hinzufügen
                </button>
              )}

              {/* FINAL SUBMIT */}
              <div className="guest-bottom">
                <button type="submit" className="guest-checkin">
                  Bestätigen
                </button>
              </div>

              {/* BACK BUTTON */}
              <button
                type="button"
                className="guest-back-btn"
                onClick={async () => {
                  const isValid = await trigger("stand"); // validate stand only

                  if (isValid) {
                    goBackToMainStep(); // go to step 2 only if stand selected
                  }
                }}
              >
                ← Zurück
              </button>
            </div>
          </form>
        </div>
      )}

      {/* SUCCESS CONFIRMATION */}
      {step === 3 && (
        <CheckinSuccess
          stand={stand}
          info={"eingecheckt"}
          check={"checkin"}
          onDone={data.onDone}
        />
      )}
    </div>
  );
}
